import { AxiosError } from 'axios';

export function axiosErrorToString(err: any) {
    // is axios error?
    if (typeof err !== 'object') {
        return String(err);
    }

    if (err.response) {
        const axiosError = err as AxiosError;
        const resp = axiosError.response!;
        let errStr = `HTTP ${resp.status} ${resp.statusText}`;
        const data = resp.data;
        if (data != null && typeof data === 'object') {
            const detail = (data as any).error || (data as any).message;
            errStr += `: ${detail ? String(detail) : JSON.stringify(data)}`;
        } else if (data) {
            errStr += `: ${data}`;
        }

        return errStr;
    } else {
        return "Request failed without a response";
    }
}
